(function () {
  var WIDGET_SELECTOR = 'recharge-subscription-widget';
  var UPDATED_FLAG = 'delavieSubscriptionCopyUpdated';
  var OBSERVER_FLAG = 'delavieSubscriptionObserverAttached';
  var EVENT_FLAG = 'delavieSubscriptionEventsAttached';
  var SHADOW_OBSERVER_FLAG = '__delavieSubscriptionObserverAttached';
  var SHADOW_PENDING_FLAG = '__delavieSubscriptionEnhancePending';

  var config = {
    badgeText: '<b style="font-weight: 800;">50% OFF</b> YOUR FIRST ORDER',
    benefits: [
      '<b>50% off</b> your first order – once per customer.',
      '<b>20% off</b> recurring orders.',
      'No commitment – skip, pause, or cancel any time.',
    ],
  };

  function normalizedText(element) {
    return (element && element.textContent ? element.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function hasChildren(element) {
    return Boolean(element && element.children && element.children.length);
  }

  function parseMoney(text) {
    var value = String(text || '').replace(/,/g, '').match(/[-+]?\d*\.?\d+/);
    return value ? Number(value[0]) : null;
  }

  function formatMoneyLike(sourceText, amount) {
    var text = String(sourceText || '').trim();
    var prefix = text.match(/^[^\d\-+]*/);
    var suffix = text.match(/[^\d.,\s]*$/);

    return (prefix ? prefix[0] : '') + amount.toFixed(2) + (suffix ? suffix[0] : '');
  }

  function updateBadge(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;

    var badgeSelector = [
      '[part*="badge"]',
      '.rc-purchase-option__badge',
      '[class*="badge"]',
    ].join(',');

    root.querySelectorAll(badgeSelector).forEach(function (badge) {
      var text = normalizedText(badge);
      if (hasChildren(badge)) return;
      if (text.length > 40) return;
      if (!/save\s*20\s*%/i.test(text)) return;

      badge.innerHTML = config.badgeText;
    });
  }

  function updateDiscountedPrice(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;

    var optionSelector = [
      '[part*="rc-purchase-option__subscription"]',
      '.rc-purchase-option__subscription',
    ].join(',');

    root.querySelectorAll(optionSelector).forEach(function (option) {
      if (!option || typeof option.querySelector !== 'function') return;

      var originalPrice = option.querySelector('[part*="original-price"],.rc-purchase-option__original-price');
      var discountedPrice = option.querySelector('[part*="discounted-price"],.rc-purchase-option__discounted-price');
      var originalValue = parseMoney(normalizedText(originalPrice));

      if (originalValue === null || !discountedPrice) return;

      var updatedPrice = formatMoneyLike(normalizedText(originalPrice), originalValue * 0.5);
      if (normalizedText(discountedPrice) === updatedPrice) return;

      discountedPrice.textContent = updatedPrice;
    });
  }

  function createBenefitItem(documentRef, benefitHtml) {
    var item = documentRef.createElement('li');
    item.innerHTML = benefitHtml;

    if (item.style) {
      item.style.listStyle = 'none';
    }
    return item;
  }

  function replaceBenefitList(list) {
    if (!list) return;
    if (list.dataset && list.dataset[UPDATED_FLAG] === 'true') return;

    var documentRef = list.ownerDocument || (typeof document !== 'undefined' ? document : null);
    if (!documentRef || typeof documentRef.createElement !== 'function') return;
    if (typeof list.replaceChildren !== 'function') return;

    var items = config.benefits.map(function (benefit) {
      return createBenefitItem(documentRef, benefit);
    });

    list.replaceChildren.apply(list, items);
    if (list.dataset) {
      list.dataset[UPDATED_FLAG] = 'true';
    }
  }

  function updateBenefits(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;

    var listSelector = [
      '[part*="benefits__list"]',
      '.rc-benefits__list',
      '[role="list"]',
      'ul',
      'ol',
    ].join(',');

    root.querySelectorAll(listSelector).forEach(function (list) {
      var text = normalizedText(list);
      if (list.dataset && list.dataset[UPDATED_FLAG] === 'true') return;
      if (!/no commitment/i.test(text) && !/cancel any\s*time/i.test(text) && !/cancel anytime/i.test(text)) return;

      replaceBenefitList(list);
    });

    root.querySelectorAll('li,[role="listitem"]').forEach(function (item) {
      var text = normalizedText(item);
      if (!/no commitment/i.test(text) && !/cancel any\s*time/i.test(text) && !/cancel anytime/i.test(text)) return;
      if (typeof item.closest !== 'function') return;

      replaceBenefitList(item.closest('ul,ol,[role="list"],[part*="benefits__list"],.rc-benefits__list'));
    });
  }

  function enhanceShadowRoot(shadowRoot) {
    updateBadge(shadowRoot);
    updateDiscountedPrice(shadowRoot);
    updateBenefits(shadowRoot);

    if (typeof shadowRoot.querySelectorAll !== 'function') return;

    shadowRoot.querySelectorAll('*').forEach(function (element) {
      if (!element.shadowRoot) return;

      enhanceShadowRoot(element.shadowRoot);
      observeShadowRoot(element.shadowRoot);
    });
  }

  function observeShadowRoot(shadowRoot) {
    if (!shadowRoot || shadowRoot[SHADOW_OBSERVER_FLAG]) return;
    if (typeof MutationObserver !== 'function') return;

    shadowRoot[SHADOW_OBSERVER_FLAG] = true;
    var observer = new MutationObserver(function () {
      if (shadowRoot[SHADOW_PENDING_FLAG]) return;

      shadowRoot[SHADOW_PENDING_FLAG] = true;
      setTimeout(function () {
        shadowRoot[SHADOW_PENDING_FLAG] = false;
        enhanceShadowRoot(shadowRoot);
      }, 0);
    });
    observer.observe(shadowRoot, {
      childList: true,
      subtree: true,
    });
  }

  function enhanceWidgetSoon(widget) {
    setTimeout(function () {
      if (widget.shadowRoot) {
        enhanceShadowRoot(widget.shadowRoot);
      }
    }, 0);
  }

  function attachWidgetEvents(widget) {
    if (!widget || !widget.dataset || widget.dataset[EVENT_FLAG] === 'true') return;

    widget.dataset[EVENT_FLAG] = 'true';
    widget.addEventListener('click', function () {
      enhanceWidgetSoon(widget);
    });
    widget.addEventListener('change', function () {
      enhanceWidgetSoon(widget);
    });
  }

  function enhanceWidget(widget) {
    if (!widget) return;
    attachWidgetEvents(widget);

    if (widget.shadowRoot) {
      enhanceShadowRoot(widget.shadowRoot);
      observeShadowRoot(widget.shadowRoot);
      setTimeout(function () {
        enhanceShadowRoot(widget.shadowRoot);
      }, 500);
      return;
    }

    if (widget.dataset && widget.dataset[OBSERVER_FLAG] === 'true') return;
    if (widget.dataset) {
      widget.dataset[OBSERVER_FLAG] = 'true';
    }

    var attempts = 0;
    var interval = setInterval(function () {
      attempts += 1;

      if (widget.shadowRoot) {
        clearInterval(interval);
        enhanceShadowRoot(widget.shadowRoot);
        observeShadowRoot(widget.shadowRoot);
      }

      if (attempts >= 40) {
        clearInterval(interval);
      }
    }, 250);
  }

  function init(root) {
    var searchRoot = root || (typeof document !== 'undefined' ? document : null);
    if (!searchRoot || typeof searchRoot.querySelectorAll !== 'function') return;

    searchRoot.querySelectorAll(WIDGET_SELECTOR).forEach(enhanceWidget);
  }

  var api = {
    config: config,
    enhanceShadowRoot: enhanceShadowRoot,
    enhanceWidget: enhanceWidget,
    init: init,
  };

  if (typeof window !== 'undefined') {
    window.DelavieRechargeWidget = api;
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    if (typeof MutationObserver === 'function') {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!node || node.nodeType !== 1) return;
            if (node.matches && node.matches(WIDGET_SELECTOR)) {
              enhanceWidget(node);
            }
            init(node);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }
})();
